import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-36769a91")

_pushScopeId("data-v-36769a91")
const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "line" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_checkTitle = _resolveComponent("checkTitle")
  const _component_checkDescrip = _resolveComponent("checkDescrip")
  const _component_checkPosition = _resolveComponent("checkPosition")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", {
      class: "ui__checkItem_main",
      id: _ctx.renderData.itemCode
    }, [
      _createVNode(_component_checkTitle, {
        itemCode: _ctx.renderData.itemCode,
        titleCont: _ctx.renderData.itemTitle,
        count: _ctx.renderData.itemCount
      }, null, 8, ["itemCode", "titleCont", "count"]),
      (_ctx.renderData.itemCode === 'Accident' || _ctx.renderData.itemCode === 'Fire' || _ctx.renderData.itemCode === 'SoakWater')
        ? (_openBlock(), _createBlock("div", _hoisted_1, [
            _createVNode(_component_checkDescrip, {
              itemCode: _ctx.renderData.itemCode
            }, null, 8, ["itemCode"])
          ]))
        : _createCommentVNode("", true),
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.renderData.itemList, (item) => {
        return _withDirectives((_openBlock(), _createBlock(_component_checkPosition, {
          key: `${_ctx.renderData.itemCode}${item.areaCode}`,
          carPositionRenderData: item,
          carPositionRenderKey: `${_ctx.renderData.itemCode}${item.areaCode}`
        }, null, 8, ["carPositionRenderData", "carPositionRenderKey"])), [
          [_vShow, !_ctx.state.tocOnlyShowFlaw || (_ctx.state.tocOnlyShowFlaw && item.defectItemCount > 0)]
        ])
      }), 128))
    ], 8, ["id"]),
    _hoisted_2
  ]))
})